export default __webpack_public_path__ + "static/media/icon-photo-placeholder.38be5d68.svg";